import React, {useEffect, useState, Fragment} from 'react';
import Typography from '@material-ui/core/Typography';
import Create_workspace_popup from './Create_workspace';
import Button from '@material-ui/core/Button';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import {List, Loader} from '../../components';
import {connect} from 'react-redux';


function Workspaces(props){
  const[new_workspace_popup, setNewWorkspace]=useState(false);
  const[search, setSearch]=useState('');
  useEffect(()=>{if(props.workspaces==undefined){props.getWorkspaces();}},[]);

  let workspaces=[]; if(props.workspaces!=undefined){for(let w_k in props.workspaces){let w=props.workspaces[w_k]; if(search=='' || w.name.toLowerCase().includes(search.toLowerCase())==true || w.id==search.toLowerCase()){workspaces.push({id:w.id, main_text:w.name, icon:(w.new==true)?<FiberNewIcon color='secondary'/>:(w.admin==true)?<SupervisorAccountIcon color='primary'/>:<PersonIcon color='primary'/>});}}}
  if(workspaces.length==1 && window.location.href.includes('switch')==false){props.getWorkspace(workspaces[0].id);}
    return(
      <Fragment>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{position:'relative', width:'100%', height:'100vh', maxWidth:'600px', overflowY:'scroll', boxShadow:'0 0 15px 5px rgba(31, 73, 125, 0.8)'}}>
        <Typography onClick={props.logout} color='primary' style={{cursor:'pointer', position:'absolute', top:'10px', right:'20px'}}><Button size='small' variant='outlined'>Logout</Button></Typography>
        <Typography variant='h6' color='primary' style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'100px', textAlign:'center'}}>Select Workspace</Typography>
        {(props.workspaces==undefined || Object.keys(props.workspaces).length<10)?null:<div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'10px', marginBottom:'-30px'}}><TextField type='name' InputProps={{startAdornment:<SearchIcon/>}} variant='outlined' size='small' label='Search' value={search} onChange={(e)=>{setSearch(e.target.value)}} style={{width:'calc(100% - 20px)', maxWidth:'260px', marginTop:'5px', marginBottom:'5px', backgroundColor:'#f7f9fc'}}/></div>}
        <div style={{width:'100%', marginTop:'50px', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div style={{width:'100%', maxWidth:'260px', height:'240px', backgroundColor:'white', borderRadius:'5px', position:'relative'}}><List onClick={(x)=>{props.getWorkspace(x.id)}} list_data={workspaces}/></div>
        </div>
        <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'50px'}}><Button color='secondary' variant='contained' onClick={()=>{setNewWorkspace(true);}}>New Workspace</Button></div>
        </div>
      </div>
      {(new_workspace_popup==false)?null:<Create_workspace_popup handleClose={()=>{setNewWorkspace(false);}}/>}
      <Loader loading={(props.workspaces==undefined)?true:false}/>
      </Fragment>
    )


}



export default connect(ss, dd)(Workspaces);


function ss(state){
  return{
    workspaces:state.workspaces.data
  }
}

function dd(dispatch){
  return{
    getWorkspaces:()=>{dispatch({type:'REQUEST_INDEX_WORKSPACES'});},
    getWorkspace:(id)=>{dispatch({type:'REQUEST_GET_CURRENT_WORKSPACE', id:id});},
    logout:()=>{dispatch({type:'REQUEST_LOGOUT'});}
  }
}
